(() => {
  'use strict';
  const message = 'Please wait while we download products…';
  const sourceSelector = [
    'mqsc-status', 'mqsh-status', 'groove-status', 'mqsi-status',
    'mqsdig-status', 'mqsd-status', 'mqsl-status', 'mqsia-status',
    'mqsmb-status', 'mqsm-loading', 'mqsg-status', 'mqsw-status', 'mqs-status'
  ].map(name => '[data-' + name + ']').join(',');
  const panels = new Map();
  let scheduled = false;
  function loading(source) {
    return !source.hidden && /^(?:loading|checking|preparing|please wait while we download)\b/i.test(source.textContent.trim());
  }
  function update() {
    scheduled = false;
    document.querySelectorAll(sourceSelector).forEach(source => {
      const panel = source.closest('.mqsm, [data-mqs-workholding], .mqs-thread-search');
      if (!panel) return;
      if (!panels.has(panel)) {
        const notice = document.createElement('p');
        notice.className = 'mqs-category-loading';
        notice.hidden = true;
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.setAttribute('aria-atomic', 'true');
        const heading = panel.querySelector(':scope > header, :scope > .mqs-thread-search__heading');
        if (heading) heading.after(notice); else panel.prepend(notice);
        panels.set(panel, notice);
        panel.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link || notice.hidden || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          // Keep the current download running when its box is clicked again.
          const target = new URL(link.href, location.href);
          if (target.origin === location.origin && target.pathname === location.pathname && target.search === location.search) event.preventDefault();
        });
      }
    });
    for (const [panel, notice] of panels) {
      if (!panel.isConnected) { panels.delete(panel); continue; }
      let busy = false;
      panel.querySelectorAll(sourceSelector).forEach(source => {
        const active = loading(source);
        if (source.classList.contains('mqs-category-loading-source') !== active) source.classList.toggle('mqs-category-loading-source', active);
        busy = busy || active;
      });
      if (busy && notice.textContent !== message) notice.textContent = message;
      if (notice.hidden === busy) notice.hidden = !busy;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  update();
  const main = document.querySelector('#main') || document.body;
  new MutationObserver(schedule).observe(main, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['hidden']});
  document.addEventListener('shopify:section:load', schedule);
})();
